// @core/api/endpoints/webhook/get_webhook_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  WebhookPolicyResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Get entity webhook policy
 * Returns the webhook policy directly attached to the specified entity (if any). Does NOT resolve inheritance — use ResolveWebhookContext for that.
 */
export async function GetWebhookPolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<WebhookPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/webhooks/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<WebhookPolicyResponse>(requestPath, { ...requestOptions });
}
